import React from 'react';
import {Link} from 'react-router-dom';
import Masonry from 'react-masonry-component';
import ReactFireComponent from '../react-fire-component/react-fire-component';
import Content from '../content/content';
import './booth.css';

/** @class Booth
  * A Booth component displays a booth's
  * interactive content to expo visitors.
  */
export default class Booth extends ReactFireComponent {
  /** @constructor
    * Builds a new instance of a Booth component.
    */
  constructor(props) {
    super(props);
    this.state = {interior: "", contents: []}
    this.close = this.close.bind(this);
  }
  /** @function componentWillMount
    * Connects the Booth component to the corresponding
    * Firebase real-time database entry.
    */
  componentWillMount() {
    this.bindAsObject(this.props.dataURL + '/metadata/interior', 'interior');
    this.bindAsArray(this.props.dataURL + '/contents', 'contents');
  }
  /** @function componentWillUnmount
    * Disconnects the component from the Firebase database.
    */
  componentWillUnmount(){
    this.unbind('contents');
    this.unbind('interior');
  }

  /** @method close
    * Displays an alert explaining that close is disabled.
    */
  close(event) {
    event.preventDefault();
    window.location.hash = window.location.hash.replace('/contents', '');
    return false;
  }
  /** @function
   * Renders the Booth component.
   */
   render() {
     var items = this.state.contents.filter((item) => {
       return item.published;
     }).map((item, index) => {
       return (
           <Content key={index} {...item} />
       )
     });

     var masonryOptions = {
       itemSelector: '.grid-item',
       columnWidth: '.grid-sizer',
       percentPostion: true,
       resize: true
     }

     var style = {
       backgroundColor: this.props.overlayColor,
       backgroundPosition: "center",
       backgroundSize: "contains",
       backgroundImage: `url(${this.state.interior})`
     };

     return (
       <div className="booth">
         <div className="booth-overlay" style={style}></div>
         <div className="booth-contents">
          <div className="close-booth">
            <Link to={`/show/hall/${this.props.hallId}`} onClick={this.close}>
              <i className="fa fa-times"></i> Close
            </Link>
          </div>
          <Masonry className="grid" options={masonryOptions}
          ref={(c)=>{this.masonry = this.masonry || c}}
          disableImagesLoaded={false}
          updateOnEachImageLoad={false}
            >
            <div className="grid-sizer"></div>
            {items}
          </Masonry>
        </div>
      </div>
    )
   }
 }



// WEBPACK FOOTER //
// ./src/components/booth/booth.js